/**
 * mask text
 */

const HELLOPANDA_MASK = {
  init: function() {
    document.addEventListener('DOMContentLoaded', function() {
  
      const containers = document.querySelectorAll('.wp-block-hellopanda-masktext-block p');
      containers.forEach(container => {

        let observer;
        if (observer) {
          observer.disconnect();
        }

        const screen = container.dataset.screen === 'true' ? true : false ;
        const repeat = container.dataset.repeat === 'true' ? true : false ;

        if (screen || repeat) {
          container.setAttribute('data-style', container.getAttribute('style'));
          container.removeAttribute('style');
        }

        observer = new IntersectionObserver(
          ([entry]) => {
            
            if (!screen && !repeat) {
              //
            } else if (screen && !repeat) {
              if (entry.isIntersecting) {
                container.setAttribute('style', container.dataset.style);
              }
            } else if (screen && repeat) {
              if (entry.isIntersecting) {
                container.setAttribute('style', container.dataset.style);
              } else {
                container.removeAttribute('style');
              }
            }

          },
          { 
            root: document,
            threshold: [0, 1],
            rootMargin: `0px 0px 0px 0px`,
            /* required options*/
            trackVisibility: true,
            delay: 100 // minimum 100
          }
        );

        // 옵저버 수행
        observer.observe(container);

      });
      
    });
  }
};
HELLOPANDA_MASK.init();